import { StatusFormatter } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { VatDeclarationStatus as VatDeclarationStatusEnum } from '../../../../enums/vatDeclarationStatus'
import { vatDeclarationStatusToStatusVariant } from '../../consts/vatDeclarationStatusToStatusVariant'
import { vatDeclarationStatusToTitleKey } from '../../consts/vatDeclarationStatusToTitleKey'

interface VatDeclarationStatusProps {
  status: VatDeclarationStatusEnum
}

export const VatDeclarationStatus = ({ status }: VatDeclarationStatusProps): ReactElement => {
  const { t } = useTranslation()

  const titleKey = vatDeclarationStatusToTitleKey[status]
  const variant = vatDeclarationStatusToStatusVariant[status]

  return <StatusFormatter variant={variant} title={t(titleKey)} />
}
